import { PartialTranslation } from '../translations';

export const uk: PartialTranslation = {
  newChat: 'Новий чат',
  search: 'Пошук',
  user: 'Користувач',
  settings: 'Налаштування',
  language: 'Мова',
  getHelp: 'Отримати допомогу',
  viewAllPlans: 'Переглянути всі плани',
  learnMore: 'Дізнатися більше',
  logOut: 'Вийти',
  chooseLanguage: 'Вибрати мову',
  chooseYourPreferredLanguage: 'Виберіть вашу бажану мову',
  searchLanguages: 'Шукати мови...',
  autoDetect: 'Автоматичне виявлення',
  noLanguagesFound: 'Мови не знайдено',
  askAnything: 'Запитайте що завгодно',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'Особистий',
  freePlan: 'Безкоштовний план',
  current: 'Поточний',
  close: 'Закрити',
  archive: 'Архівувати',
  delete: 'Видалити',
  confirmDelete: 'Ви впевнені, що хочете видалити цей чат?',
  confirmArchive: 'Ви впевнені, що хочете архівувати цей чат?',
  deleteCannotUndo: 'Цю дію неможливо скасувати.',
  archiveCanFind: 'Ви зможете знайти його в списку архіву після архівування.',
  // 资源面板
  resources: 'Ресурси',
  addResource: 'Додати ресурс',
  deleteResource: 'Видалити ресурс',
  noMatchingResourcesFound: 'Відповідних ресурсів не знайдено',
  noResourcesAvailable: 'Немає доступних ресурсів',
  hideResources: 'Приховати ресурси',
  showResources: 'Показати ресурси',
  
  // 聊天输入框
  typeMessage: 'Введіть повідомлення...',
  thinkingOptions: 'Варіанти мислення',
  deleteFile: 'Видалити файл',
  clearSelection: 'Очистити вибір',
  
  // 思考模式选项
  deepInsight: 'Глибоке розуміння · Поверхневий аналіз',
  deepInsightDesc: 'Швидке розуміння ключових моментів',
  deepExploration: 'Глибоке дослідження · Комплексний аналіз',
  deepExplorationDesc: 'Багатовимірне глибоке дослідження',
  deepDeconstruction: 'Глибока деконструкція · Систематичний аргумент',
  deepDeconstructionDesc: 'Поетапний прогресивний аналіз',
  
  // 写作模式选项
  contractReview: 'Огляд контракту · Ідентифікація ризиків',
  contractReviewDesc: 'Аналіз пунктів та перевірка відповідності',
  textPolish: 'Редагування тексту · Професійне вираження',
  textPolishDesc: 'Оптимізація мови та корегування структури',
  legalDocuments: 'Юридичні документи · Стандартне складання',
  legalDocumentsDesc: 'Професійне написання юридичних документів',
  addAttachment: 'Додати вкладення',
  sendMessage: 'Надіслати повідомлення',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'Увійти',
  register: 'Зареєструватися',
  welcomeBack: 'Ласкаво просимо до LawHelper',
  loginSubtitle: 'Ваш AI Асистент з Правових Досліджень',
  continueWithGoogle: 'Продовжити з Google',
  continueWithMicrosoft: 'Продовжити з Microsoft',
  continueWithWeChat: 'Продовжити з WeChat',
  orContinueWith: 'або продовжити з',
  emailTab: 'Ел. пошта',
  phoneTab: 'Телефон',
  emailPlaceholder: 'Введіть вашу пошту',
  phonePlaceholder: 'Введіть номер телефону',
  codePlaceholder: 'Введіть 6-значний код',
  sending: 'Надсилання...',
  verifying: 'Перевірка...',
  verify: 'Підтвердити',
  sendMagicLink: 'Надіслати магічне посилання',
  getVerificationCode: 'Отримати код',
  resendCode: 'Надіслати код повторно',
  resendIn: 'Надіслати повторно через',
  magicLinkSent: 'Магічне посилання надіслано на вашу пошту',
  magicLinkHint: 'Ми надішлемо безпечне посилання на вашу пошту',
  otpSent: 'Код підтвердження надіслано',
  agreeToTerms: 'Продовжуючи, ви погоджуєтесь з нашими',
  privacyPolicy: 'Політика конфіденційності',
  termsOfService: 'Умови використання',
  and: 'та',
  privacyTitle: 'Ваша конфіденційність важлива',
  privacyIntro: 'Ми використовуємо файли cookie та подібні технології для забезпечення найкращого досвіду.',
  essentialCookies: 'Необхідні cookie',
  essentialDesc: 'Потрібні для роботи сайту',
  analyticsCookies: 'Аналітичні cookie',
  analyticsDesc: 'Допомагають нам покращувати сервіс',
  marketingCookies: 'Маркетингові cookie',
  marketingDesc: 'Використовуються для персоналізованого контенту',
  acceptAll: 'Прийняти всі',
  essentialOnly: 'Лише необхідні',
  customize: 'Налаштувати',
  savePreferences: 'Зберегти налаштування',
  back: 'Назад',
  readPrivacyPolicy: 'Читати політику конфіденційності',
  cookiePolicy: 'Політика cookie',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'Перевірка ШІ',
  aiDraft: 'Чернетка ШІ',
  smartAssistant: 'Шаблон',

  // 知识库搜索
  enableKnowledgeSearch: 'Увімкнути пошук',
  knowledgeSearchDesc: 'ШІ шукає у ваших документах',
  clickToDisable: 'Вимкнути',
  clickToEnable: 'Увімкнути',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Закрити панель ресурсів',
  uploading: 'Завантаження %{fileName}...',
  processing: 'Обробка %{fileName}...',
  uploadSuccess: '✓ %{fileName} завантажено',
  uploadError: '✗ Помилка завантаження: %{error}',
  quickAnswer: 'Швидка відповідь',
  quickAnswerDesc: 'Швидка відповідь на прості запитання',
  cancelRequest: 'Скасувати',
  library: 'Бібліотека',
  filterAll: 'Усе',
  filterChat: 'Чати',
  filterReview: 'Перевірка',
  filterDraft: 'Чернетка',
  filterTemplate: 'Шаблон',
  filterForm: 'Форма',
  thinking: 'Думаю...',
  thinkingProcess: 'Процес мислення',
  analyzingLegalLogic: 'Аналіз юридичної логіки...',
  lawhelperThinking: 'Lawhelper думає...',
  serviceError: 'Помилка сервісу',
  uploaded: 'Завантажено',
  settingsGeneral: 'Загальні',
  settingsNotifications: 'Сповіщення',
  settingsAppearance: 'Вигляд',
  settingsProfile: 'Профіль',
  settingsResponseNotifications: 'Сповіщення про відповіді',
  settingsResponseNotificationsDesc: 'Сповіщення після завершення відповіді ШІ',
  settingsColorMode: 'Колірний режим',
  settingsLight: 'Світлий',
  settingsDark: 'Темний',
  settingsSystem: 'Системний',
  about: 'Про програму',
  reviewTitle: 'Перевірка документа',
  exitReview: 'Вийти з перевірки',
  uploadPrompt: 'Завантажте PDF для перевірки',
  uploadButton: 'Обрати файл',
  startChatConfig: 'Введіть "Перевірити документ"',
  reviewPlaceholder: 'Введіть повідомлення...',
  analyzing: 'Перевірка...',
  reviewComplete: 'Перевірка завершена',
  issuesFound: 'Знайдено %{count} проблем',
  draftTitle: 'Складання юридичного документа',
  draftPlaceholder: 'Редагуйте тут або попросіть ШІ...',
  analyzingTemplate: 'Аналіз шаблону %{name}...',
  templateAnalyzed: '✅ Шаблон %{name} проаналізовано!',
  templateAnalysisPrompt: 'Проаналізувати ключові пункти',
  parsingFailed: '⚠️ Не вдалося розібрати файл.',
  generating: 'Генерація...',
  generatedSuccess: '✅ Документ створено!',
  drafterWelcome: 'Ласкаво просимо до ШІ-помічника документів',
  drafterYouCan: 'Ви можете:',
  drafterUploadTemplate: 'Завантажити шаблон для аналізу',
  drafterDescribeNeeds: 'Описати вимоги до документа',
  drafterLetAiHelp: 'ШІ допоможе скласти договори, угоди тощо',
  drafterExamples: 'Приклади:',
  drafterExampleRental: '"Складіть договір оренди"',
  drafterExampleLabor: '"Заповніть трудовий договір"',
  drafterInputPlaceholder: 'Опишіть ваші потреби...',
  drafterThinking: 'Думаю...',
  drafterHistoryTitle: 'Історія',
  drafterNoHistory: 'Немає історії',
  drafterNewChat: 'Новий чат',
  drafterHistory: 'Історія',
  drafterRemoveAttachment: 'Видалити вкладення',
  drafterLineHeight: 'Міжрядковий інтервал',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Експорт у Word (.docx)',
  drafterExportPdf: 'Експорт у PDF',
  drafterSave: 'Зберегти документ',
  drafterDownload: 'Завантажити документ',
  drafterUndo: 'Скасувати',
  drafterRedo: 'Повторити',
  drafterBold: 'Жирний',
  drafterItalic: 'Курсив',
  drafterStrike: 'Закреслений',
  drafterUnderline: 'Підкреслений',
  drafterHighlight: 'Виділити',
  drafterLink: 'Вставити посилання',
  drafterAlignLeft: 'По лівому краю',
  drafterAlignCenter: 'По центру',
  drafterAlignRight: 'По правому краю',
  drafterAlignJustify: 'По ширині',
  drafterList: 'Список',
  drafterBulletList: 'Маркований список',
  drafterOrderedList: 'Нумерований список',
  drafterTaskList: 'Список завдань',
  drafterOpenResource: 'Відкрити ресурси',
  drafterStopGeneration: 'Зупинити генерацію',
  drafterAgentMode: 'Режим Агента активний',
  drafterAgentModeOn: 'Режим Агента активний',
  drafterAgentModeOff: 'Звичайний режим',
  drafterUploadAttachment: 'Завантажити вкладення',
  drafterExit: 'Вихід',
  drafterConfirm: 'Підтвердити',
  drafterOpenLink: 'Відкрити посилання',
  drafterDeleteLink: 'Видалити посилання',
  drafterQuote: 'Цитата',
  workflowTitle: 'ШІ-процес',
  workflowRunning: 'Виконується...',
  workflowReady: 'Готовий',
  workflowCompleted: 'Завершено',
  workflowStartFailed: 'Не вдалося запустити процес',
  workflowExecutionFailed: 'Помилка виконання процесу',
  workflowInterrupted: 'Процес перервано',
  workflowProcessing: 'Обробка...',
  workflowStepsCompleted: 'кроків завершено',
  workflowStepsTotal: 'Процес завершено (%{count} кроків)',
  acceptChanges: 'Прийняти зміни',
  rejectChanges: 'Відхилити зміни',
  changesAccepted: 'Зміни прийнято',
  changesRejected: 'Зміни відхилено',
  stopWorkflow: 'Зупинити',
  restartWorkflow: 'Перезапустити',
  startDrafting: 'Почати складання',
  interrupt: 'Зупинити',
  documentSubject: 'Тема документа *',
  documentType: 'Тип документа',
  jurisdiction: 'Юрисдикція',
  specialRequirements: 'Особливі вимоги (необовʼязково)',
  clickStartDrafting: 'Натисніть "Почати складання"',
  docTypeContract: 'Договір',
  docTypeAgreement: 'Угода',
  docTypeNotice: 'Повідомлення',
  docTypeLetter: 'Лист',
  docTypePetition: 'Клопотання',
  docTypeWill: 'Заповіт',
  docTypePowerOfAttorney: 'Довіреність',
  countryChina: 'Китай',
  countryUSA: 'США',
  countryGermany: 'Німеччина',
  countryJapan: 'Японія',
  countryFrance: 'Франція',
  countryUK: 'Велика Британія',
  citationVerified: 'Підтверджено',
  citationUnverified: 'Не підтверджено',
  imageLoadFailed: 'Не вдалося завантажити зображення',
  smartDocTitle: 'Розумний помічник документів',
  smartDocChatTitle: 'ШІ-помічник документів',
  smartDocDropPrompt: 'Перетягніть PDF сюди',
  smartDocSelectFile: 'Обрати файл',
  smartDocOr: 'або',
  smartDocWelcomeTitle: 'Ласкаво просимо до ШІ-помічника',
  smartDocWelcomeYouCan: 'Ви можете:',
  smartDocUploadForAI: 'Завантажити шаблон',
  smartDocDescribeDoc: 'Описати вимоги',
  smartDocLetAIDraft: 'ШІ допоможе з договорами',
  smartDocExamples: 'Приклади:',
  smartDocExampleRental: '"Складіть договір оренди"',
  smartDocExampleLabor: '"Заповніть трудовий договір"',
  smartDocInputPlaceholder: 'Опишіть потреби...',
  smartDocRemoveAttachment: 'Видалити вкладення',
  smartDocOpenResources: 'Відкрити ресурси',
  smartDocExit: 'Вихід',
  reviewStartFailed: 'Не вдалося запустити перевірку',
  reviewFailed: 'Перевірка не вдалася',
  reviewFoundIssues: 'Перевірка завершена, %{count} проблем.',
  cannotReadStream: 'Неможливо прочитати потік',
  parseEventFailed: 'Помилка аналізу події',
  errorPrefix: 'Помилка',
  unknownError: 'Невідома помилка',
  file: 'Файл',
  loading: 'Завантаження...',
  localFolders: 'Локальні папки',
  selectLocalFolder: 'Обрати локальну папку',
  reselectFolder: 'Змінити папку',
  addToContext: 'Додати до чату',
  saveFile: 'Зберегти',
  renameFile: 'Перейменувати',
  fileSaved: 'Файл збережено',
  fileRenamed: 'Файл перейменовано на %{name}',
  browserNotSupported: 'Ваш браузер не підтримує доступ до папок',
  noFolderSelected: 'Оберіть локальну папку',
  scanningFolder: 'Сканування папки...',
  selectFileToPreview: 'Оберіть файл для попереднього перегляду',
  aiAnalyze: 'ШІ-аналіз',
};
